// extracted by mini-css-extract-plugin
module.exports = {"tabSet":"TabSet_tabSet__1dk28","divider":"TabSet_divider__2xveG","frame":"TabSet_frame__fVnzq","content":"TabSet_content__29kU3"};